export default __webpack_public_path__ + "static/eco-sustainability-Recycled-badge-39faa82dada7da71769cf862abad6c16.svg";